import React, { Fragment } from "react";

const FeaturedCard = ({ item }) => {
  return (
    <Fragment key={item.id}>

    <div className="feature-card-premium">
      <div className="feature-icon-circle">
       <img src={item?.icon} alt={item.title} loading="lazy" />
      </div>

      <h5>{item?.title}</h5>

      <p>{item?.desc}</p>
    </div>
    </Fragment>
  );
};

export default FeaturedCard;
